import React from 'react'

export const DynamicYieldContent = ({ fields: { contentId } }: { fields: { contentId: string } }) => (
  <section id={contentId} aria-label={`Dynamic Yield Content - ${contentId}`}>
    <p style={{ textAlign: 'center' }}>Dynamic Yield content will be rendered here - ID: {contentId}</p>
  </section>
)
